<div class="flex w-full p-4 border-b border-b-p-content-border-color">
    <div class="flex flex-row items-center justify-start gap-2">
        @if (showBackButton && panelOpen) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                class="mr-auto"
                (click)="onBack()"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="aspect-square"
                pTooltip="Back"
                tooltipPosition="bottom"
                icon="pi pi-arrow-left">
                <span class="sr-only">Go back</span>
            </p-button>
        }

        @if (sendToMainPanelUrl && panelOpen) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                (click)="onClickSendToMainPanel()"
                class="mr-auto"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="aspect-square"
                pTooltip="View in center panel"
                tooltipPosition="bottom"
                icon="pi pi-expand">
                <span class="sr-only">Send to main panel</span>
            </p-button>
        }

        @if (showReloadButton && panelOpen) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                appFmDebounceClick
                class="mr-auto"
                (debounceClick)="onClickRefresh()"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="aspect-square"
                pTooltip="Refresh"
                tooltipPosition="bottom"
                icon="pi pi-sync">
                <span class="sr-only">Refresh</span>
            </p-button>
        }
    </div>

    <!-- Panel toggle -->
    <p-button
        [buttonProps]="{ autofocus: false }"
        [pTooltip]="panelOpen ? 'Minimize Panel' : 'Expand Panel'"
        class="ml-auto"
        (click)="onTogglePanel()"
        severity="secondary"
        [outlined]="true"
        size="small"
        styleClass="aspect-square"
        [icon]="panelOpen ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'">
        <span class="sr-only">Toggle right-hand panel</span>
    </p-button>
</div>
